import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { FaClipboardList, FaPlus } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import PageHeader from "../../../Components/PageHeader";
import Spin from "../../../Components/Spin";
import SwithBtn from "../../../Components/SwithBtn";
import { setLoading } from "../../../store/reducer/loading";
import { setUsers, updateUser } from "../../../store/reducer/user";
import api from "../../../Utils/api";
import { API_URL_FILE, IMG_USER_URL } from "../../../Utils/constants";

const Users = () => {
  const img_url_default = "./dist/";
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const users = useSelector((state) => state.user);
  const [search, setSearch] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [activation, setActivation] = useState("");

  const columns = [
    {
      name: "Avatar",
      selector: (row) => (
        <img
          style={{ marginTop: "5px" }}
          src={
            row?.img &&
            ((row?.img.split("/")).length > 1
              ? img_url_default
              : API_URL_FILE + "/" + IMG_USER_URL) + row?.img
          }
          alt={row.firstname + " " + row.lastname}
          height={50}
          width={50}
        />
      ),
    },
    {
      name: "Nom",
      selector: (row) => row.lastname.toUpperCase(),
    },
    {
      name: "Prénom",
      selector: (row) => row.firstname,
    },
    {
      name: "Contact",
      selector: (row) => row.contact,
    },
    {
      name: "Nom d'utilisateur",
      selector: (row) => row.username,
    },
    {
      name: "Roles",
      selector: (row) =>
        row.roles.includes("ROLE_ADMIN") ? "Administrateur" : "Utilisateur",
    },
    {
      name: "Status",
      selector: (row) => (row.isActif ? "Actif" : "Inactif"),
    },
    {
      name: "Activation/Désactivation",
      selector: (row) =>
        activation === row.id ? (
          <Spin size="sm" />
        ) : (
          <SwithBtn
            id={row.id}
            checked={row.isActif}
            onChange={({ target }) => handleUserActif(row.id, target.checked)}
          />
        ),
    },
    {
      name: "Action",
      cell: (row) => (
        <>
          <Button
            variant="outline-info"
            className="mr-2"
            onClick={() => navigate(`/utilisateur/${row.id}`)}
          >
            <FaClipboardList />
          </Button>

          <Button
            className="mr-2"
            variant="outline-danger"
            onClick={() => handleDeleteUser(row.id)}
          >
            <MdDelete />
          </Button>
        </>
      ),
    },
  ];

  const handleUserActif = async (id, checked) => {
    setActivation(id);
    const [userTargeted] = users.filter((user) => user.id === id);
    const dataUser = {
      ...userTargeted,
      roles: userTargeted.roles
        .filter((role) => role !== "ROLE_USER")
        .join(","),
      isActif: checked,
    };

    try {
      const { data } = await api.put(`users/${id}`, dataUser);
      if (!data.user) {
        toast.error("Vérifier vos données avant la soumission.");
        return;
      }
      dispatch(
        updateUser({
          ...userTargeted,
          isActif: checked,
        })
      );
      setFilteredData((prev) =>
        [...prev].map((user) =>
          user.id === id
            ? {
                ...user,
                isActif: checked,
              }
            : user
        )
      );
      toast.success("Mise à jour éffectuée.");
    } catch (error) {
      if (error.response.status === 401) {
        navigate("/login");
      }
    } finally {
      setActivation("");
    }
  };

  const handleDeleteUser = async (id) => {
    if (!window.confirm("Voulez-vous supprimer cet utilisateur ?")) return;
    try {
      const { data } = await api.delete(`users/${id}`);
      if (!data.Message) {
        toast.error("Erreur lors de la suppression de l'utilisateur.");
        return;
      }
      dispatch(setUsers(users.filter((user) => user.id !== id)));
      setFilteredData((prev) => [...prev].filter((user) => user.id !== id));
      toast.success("Utilisateur supprimé avec succès.");
    } catch (error) {
      toast.error("Vérifier vos données avant la soumission.");
      if (error.response.status === 401) {
        navigate("/login");
      }
    }
  };

  const handleSearch = () => {
    const filteredUsers = [...users].filter(
      (item) =>
        item.firstname.toLowerCase().includes(search.toLowerCase()) ||
        item.lastname.toLowerCase().includes(search.toLowerCase())
    );
    setFilteredData(filteredUsers);
  };

  const tableHearderStyle = {
    headCells: {
      style: {
        fontWeight: "bold",
        fontSize: "14px",
        backgroundColor: "#ccc",
      },
    },
  };

  document.title = "DashBoard | Utilisateurs";
  useEffect(() => {
    const loadUsers = async () => {
      dispatch(setLoading(true));
      try {
        const { data } = await api.get("users");
        const usersData = data.users;
        dispatch(setUsers(usersData));
        setFilteredData(usersData);
      } catch (error) {
        if (error.response.status === 401) {
          navigate("/login");
        }
      } finally {
        dispatch(setLoading(false));
      }
    };

    loadUsers();
  }, []);

  return (
    <>
      <PageHeader page="Utilisateurs" />

      {/* Main content */}
      <section className="content">
        <div className="container-fluid">
          <div className="card">
            <div className="card-header">
              <div className="card-tools">
                {/* <button
                  type="button"
                  className="btn btn-tool"
                  data-widget="collapse"
                  data-toggle="tooltip"
                  title="Collapse"
                >
                  <i className="fa fa-minus" />
                </button>
                <button
                  type="button"
                  className="btn btn-tool"
                  data-widget="remove"
                  data-toggle="tooltip"
                  title="Remove"
                >
                  <i className="fa fa-times" />
                </button> */}
                <Button
                  className="btn btn-success mr-3"
                  onClick={() => navigate("/nouvelutilisateur")}
                >
                  <FaPlus /> Ajouter
                </Button>
              </div>
            </div>
            <div className="card-body">
              {users && (
                <DataTable
                  customStyles={tableHearderStyle}
                  columns={columns}
                  data={filteredData}
                  pagination
                  responsive
                  highlightOnHover
                  subHeader
                  subHeaderComponent={
                    <input
                      className="form-control w-25"
                      placeholder="Rechercher un utilisateur..."
                      type="text"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                      onKeyUp={handleSearch}
                    />
                  }
                />
              )}
            </div>
          </div>
        </div>
      </section>
      {/* /.content */}
    </>
  );
};

export default Users;
